import {motion} from "framer-motion";
import logoround from "../../../assets/VectorSancorWhite.png";
import React from "react";
import withRoot from "../../withRoot";

const SmallLoading= () => (
    <div className="spinner" style={{height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <motion.img
            src={logoround}
            style={{height:'32px'}}
            animate={{
                opacity: [1, 1, 1, 0],
                color:[1,1,1,0],
                // backgroundColor: "#fff",
                rotate: [0, 360, 360],
            }}
            transition={{
                duration: 1.4,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: 'loop',
                repeatDelay: 0.8,
            }}
        />
    </div>
);

export default withRoot(SmallLoading);